export default "<birds-eye [job-id]=\"jobId\" [job-instance]=\"jobInstance\" [session-id]=\"sessionId\" [close-callback]=\"closeCallback\"></birds-eye>\n";